import { RSDays30Stats } from '@/api/apis/resources';

export const ThirtyDays = ({ stats }: { stats: RSDays30Stats }) => {
  return (
    <div className="text-m-r">
      {stats.successful}/{stats.total}
    </div>
  );
};
